module.exports = __webpack_public_path__ + "assets/img/department-title.8158ab11.svg";